import { createSlice } from '@reduxjs/toolkit';

type AdsSlice = {
    isTcfLoaded: boolean;
};

export const initialState: AdsSlice = {
    isTcfLoaded: false,
};

const adsSlice = createSlice({
    name: 'ads',
    initialState,
    reducers: {
        setTcfLoaded: (state) => {
            return { ...state, isTcfLoaded: true };
        },
    },
});

export const { setTcfLoaded } = adsSlice.actions;
export const reducer = adsSlice.reducer;
